var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"modal-id":"regionModal","modal-dialog":"centered,region"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h5',{staticClass:"modal-title glitch-text glitch-text--modal-region"},[_vm._v("Ваш город")])]},proxy:true},{key:"default",fn:function(ref){
var isOpen = ref.isOpen;
return [_c('region-selection',{attrs:{"is-open":isOpen}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }